import client from '@/api/client';
import { gql } from '@apollo/client';

const sendApplication = (data: {
  name: string;
  company: string;
  email: string;
  phone: string;
}) => client
  .mutate({
    mutation: gql`
      mutation applicationSendRequest(
        $name: String,
        $company: String,
        $email: String,
        $phone: String,
      ) {
        applicationSendRequest(
          name: $name,
          company: $company,
          email: $email,
          phone: $phone,
        ) {
          status
        }
      }
    `,
    variables: {
      name: data.name,
      company: data.company,
      email: data.email,
      phone: data.phone,
    },
  });

export default {
  sendApplication,
};
